import { Cell, StyledTableRow } from 'components/Table'
import { MAX_WIDTH_MEDIA_BREAKPOINT, SMALL_MEDIA_BREAKPOINT } from 'components/Tokens/constants'
import { Box } from 'rebass'
import styled, { css } from 'styled-components/macro'

export const StyledRow = styled(StyledTableRow)<{
  first?: boolean
  last?: boolean
  $loading?: boolean
}>`
  align-items: center;
  grid-template-columns: 1.4fr 1.4fr 1.8fr 1.3fr 1.3fr 1.3fr;
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  min-width: 390px;
  padding: 0;
  margin: 0;
  ${({ last, theme }) => css`
    border-bottom: ${last ? 'none' : `1px solid ${theme.primaryBorder}`};
  `}
  transition: ${({
    theme: {
      transition: { duration, timing },
    },
  }) => css`background-color ${duration.medium} ${timing.ease}`};
  transition-duration: ${({ theme }) => theme.transition.duration.fast};

  &:hover {
    ${({ $loading, theme }) =>
      !$loading &&
      css`
        background-color: ${theme.hoverDefault};
      `}
    ${({ last }) =>
      last &&
      css`
        border-radius: 0px 0px 8px 8px;
      `}
  }
`
export const StyledHeaderRow = styled(StyledRow)`
  height: 40px;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.textPrimary};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  &:hover {
    background-color: transparent;
  }

  @media only screen and (max-width: ${SMALL_MEDIA_BREAKPOINT}) {
    justify-content: space-between;
  }
`

export const TextPrimarySpace: any = { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }

export const PoolCell = styled(Cell)`
  justify-content: flex-start;
  padding: 0 8px;
  min-width: 100px;
  overflow: hidden;
  gap: 8px;
`

export const LongIcon = styled(Box)<{ isLong: boolean }>`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  background-color: ${({ theme, isLong }) => (isLong ? theme.tradeGreen : theme.tradeRed)};
  border-radius: 50%;
  line-height: 14px;
  text-align: center;
`
